// @flow
import React, { Component, Fragment } from "react";
import { Box } from "biologiatotal-ui";
import "./recoverMessage.scss";
import { Link } from "react-router-dom";

class RecoverMessage extends Component {
  render() {
    return (
      <Fragment>
        <div className="columns recover-message">
          <div className="column centered is-4 is-offset-4">
            <Box className="recover-message-content">
              <div className="recover-message-header">
                <span>CONFIRA SEU E-MAIL</span>
              </div>
              <div>
                <span className="recover-message-header-texttwo">
                  Se o e-mail informado for válido, você receberá instruções para redefinir a sua senha
                </span>
              </div>
            </Box>
            <div className="recover-message-back">
              <Link to={"/"} className="recover-message-label">
                Voltar para a home
              </Link>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

RecoverMessage.displayName = "RecoverMessage";

export default RecoverMessage;
